import createIcon from '../../createIcon';

/**
 * @component @name Business
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgN1YzSDJWMjFIMjJWN0gxMlpNNiAxOUg0VjE3SDZWMTlaTTYgMTVINFYxM0g2VjE1Wk02IDExSDRWOUg2VjExWk02IDdINFY1SDZWN1pNMTAgMTlIOFYxN0gxMFYxOVpNMTAgMTVIOFYxM0gxMFYxNVpNMTAgMTFIOFY5SDEwVjExWk0xMCA3SDhWNUgxMFY3Wk0yMCAxOUgxMlYxN0gxNFYxNUgxMlYxM0gxNFYxMUgxMlY5SDIwVjE5Wk0xOCAxMUgxNlYxM0gxOFYxMVpNMTggMTVIMTZWMTdIMThWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Business = createIcon('Business', [
  [
    'path',
    {
      d: 'M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z',
      key: '1tubfa',
    },
  ],
]);

export default Business;
